import { Component, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { AppState } from '../../../../../app.service';
import { NgForm } from '@angular/forms';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
let $ = require('jquery');
import { StorageProfileCreate } from '../storage-profile/storage-profile-create';
import { ComputeVcdConstants } from '../../compute-vcd-constants';

@Component({
  selector: 'allocation-model',
  providers: [
    TranslateService
  ],
  styles: [require('../org-vdc.wizard.scss')],
  template: require('./alloc-model.html')
})

export class AllocationModel {
  @ViewChild('allocationModel') allocationModel: NgForm;
  @Input('isVisible') isVisible: boolean;
  @Input() orgVdcId: string = '';
  @Input() editData: any;
  @Input() isWizardOpen: boolean = false;
  @Input() stepId: number;
  @Input() sddcStepData: any;
  @Output() stepEventEmitter: EventEmitter<any> = new EventEmitter();

  private subscribeHandler;
  private isTranslationready: boolean = true;
  private showGuaranteeFields: boolean = false;
  private PAYGO: string = ComputeVcdConstants.ALLOC_MODEL.PAYGO;
  private ALLOCPOOL: string = ComputeVcdConstants.ALLOC_MODEL.ALLOCPOOL;
  private loading: boolean = true;
  private selected = [];
  private showError: boolean = false;
  private isFirstLoad: boolean = false;
  private isAllocModelSelected: boolean = false;
  private toggleVisibility: string = 'hide-me';


  private mockDefaultSize = [
            { 'name': 'Small',
               'cpu': { 'units': 'GHz', 'total': 10},
               'memory': { 'units': 'GB', 'total': 30},
               'storage': { 'units': 'GB', 'total': 500}
             },
             { 'name': 'Medium',
               'cpu': { 'units': 'GHz', 'total': 20},
               'memory': { 'units': 'GB', 'total': 60},
               'storage': { 'units': 'GB', 'total': 1024}
             },
             { 'name': 'Large',
               'cpu': { 'units': 'GHz', 'total': 50},
               'memory': { 'units': 'GB', 'total': 150},
               'storage': { 'units': 'GB', 'total': 2560}
             }
     ];

  private dataModel = {
      allocModel: '',
      defaultSize: [],
      cpu: 0,
      cpuGuarantee: 0,
      cpuUnit: '',
      memory: 0,
      memoryGuarantee: 0,
      memoryUnit: '',
      storage: 0,
      storageUnit: '',
      storageStd: 0,
      storageStdUnit: '',
      storageSSD: 0,
      storageSSDUnit: '',
      stepId: -1,
      storageProfiles: [],
      isStepValid: false
  };

  constructor(public appState: AppState, private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }

  ngOnInit() {
  }

  reset() {
    this.dataModel = {
      allocModel: '',
      defaultSize: [],
      cpu: 0,
      cpuGuarantee: 0,
      cpuUnit: '',
      memory: 0,
      memoryGuarantee: 0,
      memoryUnit: '',
      storage: 0,
      storageUnit: '',
      storageStd: 0,
      storageStdUnit: '',
      storageSSD: 0,
      storageSSDUnit: '',
      stepId: -1,
      storageProfiles: [],
      isStepValid: false
    }
    this.selected = [];
    this.toggleVisibility = 'hide-me';
  }

  ngOnChanges(changes) {
    if ( !this.isWizardOpen ) {
      this.reset();
      this.allocationModel.form.reset();
      return;
    }

    if (this.stepId >= 0) {
        this.dataModel.stepId = this.stepId;
    }
  }

  toggleGuaranteeField(event) {
    this.dataModel.allocModel = event.target.value;
    this.showGuaranteeFields = (event.target.value === 'ALLOCATIONPOOL') ? true : false;
    this.isAllocModelSelected = true;
    this.emitData();
    this.toggleVisibility = 'show-me';
    $('.datagrid-column-title .checkbox').hide();
  }

  updateDefaultSize(data) {
    this.dataModel.cpu = (data) ? data.cpu.total : 0;
    this.dataModel.cpuUnit = (data) ? data.cpu.units : '';
    this.dataModel.memory = (data) ? data.memory.total : 0;
    this.dataModel.memoryUnit = (data) ? data.memory.units : '';
  }

  ngOnDestroy() {
    if (this.subscribeHandler) {
      this.subscribeHandler.unsubscribe();
    };
  }

  updateStorageProfile(event) {
      this.dataModel.storageProfiles = []; //event;
      event.forEach(element => {
            if (!element.isDeleted) {
                this.dataModel.storageProfiles.push (element);
            }
        });
      this.emitData();
  }

  refresh(state) {
    this.loading = true;
  }

  onSelectedChanged(event: any): void {
    if (this.selected.length === 2) {
      this.selected = [event[1]];
      this.updateDefaultSize(event[1]);
    } else {
      this.updateDefaultSize(event[0]);
    }
    this.stepEventEmitter.emit(this.dataModel);
  }

  emitData() {
    this.dataModel.isStepValid = false;
    let data = this.dataModel;
    let isFormValid: boolean = false;
    let isSPValid: boolean = true;
    let isDistinctSP: boolean = true;
    let isDefaultSelected: boolean = false;
    let spList = [];

    if (data.allocModel === 'ALLOCATIONPOOL') {
        if ($.trim(data.cpu) != "" &&  $.trim(data.memory) != "" && $.trim(data.cpuGuarantee) != "" &&  $.trim(data.memoryGuarantee) != "" &&
        Number(data.cpu) >= 0.26 && ( Number(data.cpuGuarantee) >= 0 && Number(data.cpuGuarantee) <= 100) &&
        Number(data.memory) >= 1 && ( Number(data.memoryGuarantee) >= 20 && Number(data.memoryGuarantee) <= 100 ) ) {
              isFormValid = true;
        }
    } else {
        if ( $.trim(data.cpu) != "" &&  $.trim(data.memory) != "" && Number(data.cpu) >= 0.26 && Number(data.memory) >= 1) {
              isFormValid = true;
        }
    }

    let len = data.storageProfiles.length;
    if (len === 0) {
        isFormValid = false;
    }
    for (let i = 0; i < len; i++) {
        spList.push (data.storageProfiles[i].name);
        if (data.storageProfiles[i].default) {
            isDefaultSelected = true;
        }
        if (!data.storageProfiles[i].isComponentValid) {
          isSPValid = false;
        }
        if ((i + 1) < len && spList.indexOf(data.storageProfiles[i + 1].name) >= 0) {
            isDistinctSP = false;
        }
    }

    this.dataModel.isStepValid = isFormValid && isSPValid && isDistinctSP && isDefaultSelected;
    this.stepEventEmitter.emit(this.dataModel);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/compute/compute-vcd/org-vdc-wizard/steps/alloc-model.component.ts